import { Injectable } from '@angular/core';

import { SlimLoadingBarService } from 'ng2-slim-loading-bar';

@Injectable()
export class LoadingPanelService {

  public isLoading: boolean;

  constructor(
    private slimLoadingBarService: SlimLoadingBarService) { }

  start() {
    this.slimLoadingBarService.start();
    this.isLoading = true;
  }

  complete() {
    this.slimLoadingBarService.complete();
    this.isLoading = false;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/commons/loading-panel.service.ts